import { SignUpStepsEnum } from "../enums/signupStepsEnum";

export const isSignUpStepEnum = (value: any): value is SignUpStepsEnum => {
  return Object.values(SignUpStepsEnum).includes(value as SignUpStepsEnum);
};